module Elma.Bindings {

    export interface ICompareProducts {

        link: string,

        productArray: KnockoutObservable<string>

    }

    export class CompareProducts {

        private generateLink(element: any, valueAccessor: () => ICompareProducts, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {

            if (!bindingContext)

                return;

            var value = valueAccessor();
            var productArray = value.productArray;

            if (productArray().length == 0) {
                $(element).closest(".js-parent-compare").addClass("hidden-xs");
                $(element).addClass("disabled-link");
            }
            else {
                $(element).closest(".js-parent-compare").removeClass("hidden-xs");
                $(element).removeClass("disabled-link");
            }

            productArray.subscribe((newValue) => {
                console.log(newValue);
                var compareLink = value.link + "&compare=";

                for (var i = productArray().length - 1; i >= 0; i--) {
                    var separator = i > 0 ? "," : "";
                    compareLink += productArray()[i] + separator;
                }
                $(element).attr("href", compareLink); // update link
            });


            $(element).closest(".js-parent-compare").on("click", function () {
                // make whole area clickable
                if (!$(element).hasClass("disabled-link")) {
                    window.location.href = $(element).attr("href");
                }
            });
        }

        public init = this.generateLink;
        public update = this.generateLink;
    }

    ko.bindingHandlers['compareProducts'] = new CompareProducts();



}